import React from "react";
import PropTypes from "prop-types";
import { TextField, FormGroup, MenuItem, Grid } from "@material-ui/core/";
import { useTranslation } from "react-i18next";

import { COUNTRIES } from "../../../../const";
import { withStyles } from "@material-ui/core/styles";
import { FormStyles } from "../../../../styles";

const CrecheInfo = props => {
  const { t } = useTranslation();

  return (
    <div>
      <FormGroup>
        <TextField
          label={t("signup.labels.creche_name")}
          name="crecheDto.nom"
          variant="outlined"
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          helperText={
            <span className={props.classes.formError}>
              {props.touched.crecheDto &&
                props.touched.crecheDto["nom"] &&
                props.errors.crecheDto &&
                props.errors.crecheDto["nom"]}
            </span>
          }
          value={props.values.crecheDto.nom}
        />
      </FormGroup>
      <Grid container spacing={24}>
        <Grid item xs={8}>
          <FormGroup>
            <TextField
              label={t("signup.labels.rue")}
              name="crecheDto[adresseCreche][rue]"
              variant="outlined"
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              helperText={
                <span className={props.classes.formError}>
                  {props.touched.crecheDto &&
                    props.touched.crecheDto["adresseCreche"] &&
                    props.touched.crecheDto["adresseCreche"]["rue"] &&
                    props.errors.crecheDto &&
                    props.errors.crecheDto["adresseCreche"] &&
                    props.errors.crecheDto["adresseCreche"]["rue"]}
                </span>
              }
              value={props.values.crecheDto.adresseCreche.rue}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={4}>
          <FormGroup>
            <TextField
              label={t("signup.labels.ville")}
              name="crecheDto[adresseCreche][ville]"
              variant="outlined"
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              helperText={
                <span className={props.classes.formError}>
                  {props.touched.crecheDto &&
                    props.touched.crecheDto["adresseCreche"] &&
                    props.touched.crecheDto["adresseCreche"]["ville"] &&
                    props.errors.crecheDto &&
                    props.errors.crecheDto["adresseCreche"] &&
                    props.errors.crecheDto["adresseCreche"]["ville"]}
                </span>
              }
              value={props.values.crecheDto.adresseCreche.ville}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("signup.labels.code_postal")}
              name="crecheDto[adresseCreche][codePostale]"
              type="number"
              variant="outlined"
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              helperText={
                <span className={props.classes.formError}>
                  {props.touched.crecheDto &&
                    props.touched.crecheDto["adresseCreche"] &&
                    props.touched.crecheDto["adresseCreche"]["codePostale"] &&
                    props.errors.crecheDto &&
                    props.errors.crecheDto["adresseCreche"] &&
                    props.errors.crecheDto["adresseCreche"]["codePostale"]}
                </span>
              }
              value={props.values.crecheDto.adresseCreche.codePostale}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              label={t("signup.labels.pays")}
              name="crecheDto[adresseCreche][pays]"
              type="text"
              variant="outlined"
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              helperText={
                <span className={props.classes.formError}>
                  {props.touched.crecheDto &&
                    props.touched.crecheDto["adresseCreche"] &&
                    props.touched.crecheDto["adresseCreche"]["pays"] &&
                    props.errors.crecheDto &&
                    props.errors.crecheDto["adresseCreche"] &&
                    props.errors.crecheDto["adresseCreche"]["pays"]}
                </span>
              }
              value={props.values.crecheDto.adresseCreche.pays}
            >
              {COUNTRIES.map(country => (
                <MenuItem key={country} value={country}>
                  {country}
                </MenuItem>
              ))}
            </TextField>
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("creche.opening_time")}
              type="Time"
              variant="outlined"
              name="horaire[ouverture]"
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              value={props.values.horaire.ouverture}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("creche.closing_time")}
              type="Time"
              variant="outlined"
              name="horaire[fermeture]"
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              value={props.values.horaire.fermeture}
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12}>
          <FormGroup>
            <TextField
              label={t("creche.informations")}
              variant="outlined"
              rows={2}
              multiline
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              name="informations"
            />
          </FormGroup>
        </Grid>
      </Grid>
    </div>
  );
};

CrecheInfo.propTypes = {
  touched: PropTypes.object,
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func
};

export default withStyles(FormStyles)(CrecheInfo);
